// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__FW9xu","active":"style_active__rbD1H","backgroundClose":"style_backgroundClose__vtnOy"};